import { Attributes, Model, Validation, ValueObject } from '@singularsystems/neo-core';
import LetterAuthorisationBatchLookup from '../Lookups/LetterAuthorisationBatchLookup';
import { GetReportTypeInfo, ReportType } from '../ReportType';
import LetterAuthorisationBatchCriteria from "./LetterAuthorisationBatchCriteria";

export default class CreateLetterAuthorisationBatchCommand extends ValueObject {

    constructor(criteria: LetterAuthorisationBatchCriteria, lookup: LetterAuthorisationBatchLookup) {
        super();
        this.makeObservable();

        const newCriteria = criteria.clone();
        newCriteria.startDate = lookup.reportStartDate ?? lookup.reportDate;
        newCriteria.endDate = lookup.reportDate;
        newCriteria.entityId = lookup.entityId;
        newCriteria.description = lookup.description;
        
        this.criteria = newCriteria;
        this.lookup = lookup;

        const reportInfo = GetReportTypeInfo(lookup.reportType);
        this.requiredSignatories = reportInfo.requiredSignatories;
        this.maximumSignatories = reportInfo.maximumSignatories;
    }

    public criteria: LetterAuthorisationBatchCriteria;

    public signatories: number[] = [];

    // Client only properties / methods

    @Attributes.NoTracking()
    public lookup: LetterAuthorisationBatchLookup;

    @Attributes.NoTracking()
    public signatoryNames: Model.ISelectedItem[] = [];

    @Attributes.NoTracking()
    public requiredSignatories: number = 0;

    @Attributes.NoTracking()
    public maximumSignatories: number = 0;

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);

        rules.failWhen(c => c.signatories.length < this.requiredSignatories, c => `At least ${c.requiredSignatories} signatories are required.`).onProperties(c => c.signatoryNames);
        rules.failWhen(c => this.maximumSignatories > 0 && c.signatories.length > this.maximumSignatories, c => `At most ${c.maximumSignatories} signatories can be selected.`).onProperties(c => c.signatoryNames);
        rules.failWhen(c => c.criteria.reportType === ReportType.PortfolioStatement && c.criteria.startDate == null, "Report start date is required.");
    }

    public toString(): string {
        return "Create Letter Authorisation Batch Command";
    }
}